import ApartmentRoundedIcon from "@mui/icons-material/ApartmentRounded";
import EastIcon from "@mui/icons-material/East";
import ForumRoundedIcon from "@mui/icons-material/ForumRounded";
import GppGoodRoundedIcon from "@mui/icons-material/GppGoodRounded";
import InstagramIcon from "@mui/icons-material/Instagram";
import PersonRoundedIcon from "@mui/icons-material/PersonRounded";
import PhoneAndroidRoundedIcon from "@mui/icons-material/PhoneAndroidRounded";
import ShowChartRoundedIcon from "@mui/icons-material/ShowChartRounded";
import XIcon from "@mui/icons-material/X";
import { Box, Button, Typography } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import React from "react";
import Community1 from "../../assets/ourcommunity-1.jpeg";
import Community2 from "../../assets/ourcommunity-2.jpeg";
import Community3 from "../../assets/ourcommunity-3.jpeg";
import Community4 from "../../assets/ourcommunity-4.jpeg";
import Community5 from "../../assets/ourcommunity-5.jpeg";
import SchoolManagement from "../../assets/sm.jpeg";
import Team from "../../assets/team.jpeg";
import Address from "../../components/address";
import Carousel from "../../components/carousel.js";

const EnhanceData = [
  {
    icon: <ForumRoundedIcon sx={{ color: "#347AEA" }} />,
    header: "Efficient Communication",
    subheader:
      "Stay connected with students and parents through instant notifications and updates.",
  },
  {
    icon: <PhoneAndroidRoundedIcon sx={{ color: "#347AEA" }} />,
    header: "Easy Access",
    subheader: "Access important information from anywhere, anytime.",
  },
  {
    icon: <ShowChartRoundedIcon sx={{ color: "#347AEA" }} />,
    header: "Comprehensive Reports",
    subheader: "Generate detailed reports for better decision-making.",
  },
];

const CommunityData = [
  Community1,
  Community2,
  Community3,
  Community4,
  Community5,
];

const TeamData = [
  {
    name: "Manjunath SV",
    position: "Founder / CEO",
    description:
      "Manjunath leads Helpsoo with a vision to revolutionize school management.",
  },
  {
    name: "Jaswanth Kilari",
    position: "Founder / Operations",
    description:
      "Jaswanth ensures our platform is robust and user-friendly. He is dedicated to providing top-notch support to our users.",
  },
];

const Home = () => {
  return (
    <>
      <Box sx={{ px: { xs: 3, lg: 30, md: 15 } }}>
        <Box
          sx={{
            display: { xs: "block", lg: "flex", md: "flex" },
            pt: { xs: 5, md: 15, lg: 15 },
          }}
        >
          <Box>
            <Typography
              sx={{
                fontSize: { lg: "3.75rem", md: "3.75rem", xs: "2.5rem" },
                lineHeight: 1,
                fontWeight: 600,
              }}
            >
              Welcome to Helpsoo
            </Typography>
            <Box sx={{ py: 4, display: "flex" }}>
              <Button
                variant="contained"
                sx={{
                  borderRadius: "1.5rem",
                  fontWeight: 600,
                  px: "1.5rem",
                  fontSize: { xs: "0.75rem" },
                  lineHeight: "1.5rem",
                  height: "3.5rem",
                }}
              >
                Get Started <EastIcon />
              </Button>

              <Button
                variant="outlined"
                sx={{
                  color: "#000",
                  borderRadius: "1.5rem",
                  px: "1.5rem",
                  fontWeight: 600,
                  fontSize: { xs: "0.875rem" },
                  lineHeight: "1.5rem",
                  height: "3.5rem",
                  mx: 2,
                }}
              >
                Learn More
              </Button>
            </Box>
          </Box>
          <Box
            sx={{ p: { lg: 10, xs: 1, md: 5 }, mx: { lg: 5, xs: 1, md: 5 } }}
          >
            <Typography>
              Connecting students and parents with school management
              effortlessly.
            </Typography>
            <Box pt={5} display={"flex"} justifyContent={"space-between"}>
              <Typography sx={{ fontSize: { xs: "0.875rem" }, pr: 2 }}>
                <PersonRoundedIcon />
                USER FRIENDLY
              </Typography>
              <Typography sx={{ fontSize: { xs: "0.875rem" }, px: 2 }}>
                <GppGoodRoundedIcon />
                SECURE
              </Typography>
              <Typography sx={{ fontSize: { xs: "0.875rem" } }}>
                <ApartmentRoundedIcon /> COMPREHENSIVE
              </Typography>
            </Box>
          </Box>
        </Box>
        <Carousel />
        <Box
          sx={{
            display: { xs: "block", lg: "flex", md: "flex" },
            py: 10,
            justifyContent: "space-evenly",
          }}
        >
          <Box
            component={"img"}
            src={SchoolManagement}
            sx={{
              borderRadius: 3,
              width: { md: "60vw", lg: "35vw", xs: "90vw" },
              objectFit: "cover",
              aspectRatio: 1 / 1,
            }}
          ></Box>

          <Box sx={{ px: { md: 5, lg: 10, xs: 1 } }}>
            <Typography sx={{ color: "#347AEA", fontWeight: "bold" }}>
              Powerful Features
            </Typography>
            <Typography
              sx={{
                fontWeight: 700,
                fontSize: "2.25rem",
                lineHeight: "2.5rem",
                py: 3,
              }}
              y
            >
              Enhance Your School Management
            </Typography>
            <Typography color={"#4b5563"}>
              Discover how Helpsoo's features can streamline your school
              management and improve communication.
            </Typography>
            {EnhanceData?.map((item) => {
              return (
                <Box key={item} sx={{ display: "flex", p: 3 }}>
                  <Box sx={{ pt: 1 / 2 }}>{item.icon}</Box>
                  <Box sx={{ mx: 2 }}>
                    <Typography fontWeight={700}>{item.header}</Typography>
                    <Typography color={"#4b5563"}>{item.subheader}</Typography>
                  </Box>
                </Box>
              );
            })}
          </Box>
        </Box>
        <Box
          sx={{
            display: { xs: "block", lg: "flex", md: "flex" },
            px: { lg: 10, xs: 1, md: 10 },
          }}
        >
          <Box>
            <Typography sx={{ fontSize: "2.25rem", fontWeight: 700 }}>
              Meet Our Team
            </Typography>
            <Typography sx={{ fontSize: "1.125rem", color: "#4b5563" }}>
              Our dedicated team is here to support your school's needs.
            </Typography>
          </Box>
          <Box sx={{ px: { lg: 5, xs: 1, md: 5 }, py: 2 }}>
            {TeamData.map((item) => {
              return (
                <Box
                  sx={{
                    display: { xs: "block", lg: "flex", md: "flex" },
                    mb: { lg: 10, md: 10, xs: 4 },
                  }}
                  key={item}
                >
                  <Box
                    component={"img"}
                    src={Team}
                    sx={{
                      objectFit: "cover",
                      width: "13rem",
                      aspectRatio: 4 / 5,
                      borderRadius: "1rem",
                    }}
                  ></Box>
                  <Box
                    sx={{
                      px: { lg: 5, md: 5, xs: 1 },
                      fontWeight: "1.125rem",
                      color: "#4b5563",
                    }}
                  >
                    <Typography sx={{ fontWeight: 600 }}>
                      {item.name}
                    </Typography>
                    <Typography>{item.position}</Typography>
                    <Typography py={2}>{item.description}</Typography>
                    {/* <Box flexGrow={1}>
                      <XIcon color="#4b5563" />
                      <InstagramIcon color="#4b5563" sx={{ px: 2 }} />
                    </Box> */}
                  </Box>
                </Box>
              );
            })}
          </Box>
        </Box>
        {/* <Box
          sx={{
            display: {
              lg: "flex",
              md: "flex",
              xs: "block",
              py: { lg: 10, md: 10, xs: 5 },
            },
          }}
          flexGrow={1}
        >
          <Box alignSelf={"center"}>
            <Typography
              sx={{
                fontSize: { lg: "3rem", md: "3rem", xs: "2.25rem" },
                fontWeight: 800,
              }}
            >
              Our Impact
            </Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              my: { xs: 5 },
              ml: { lg: "4rem", md: "4rem", xs: "0.5rem" },
            }}
          >
            <Box sx={{ px: { lg: 5, md: 2 } }}>
              <Typography
                sx={{
                  fontSize: { lg: "3.75rem", md: "3.75rem", xs: "2.25rem" },
                  fontWeight: 700,
                }}
              >
                10K+
              </Typography>
              <Typography
                sx={{
                  fontSize: { lg: "1.25rem", md: "1.25rem", xs: "1rem" },
                  color: "#4b5563",
                }}
              >
                Students Connected
              </Typography>
            </Box>
            <Box
              sx={{
                bgcolor: "#e6e6e6",
                width: "1px",
                mx: { lg: 10, md: 5, xs: 3 },
              }}
            ></Box>
            <Box>
              <Typography
                sx={{
                  fontSize: { lg: "3.75rem", md: "3.75rem", xs: "2.25rem" },
                  fontWeight: 700,
                }}
              >
                500+
              </Typography>
              <Typography
                sx={{
                  fontSize: { lg: "1.25rem", md: "1.25rem", xs: "1rem" },
                  color: "#4b5563",
                }}
              >
                Schools Managed
              </Typography>
            </Box>
          </Box>
        </Box> */}

        <Box>
          <Typography
            sx={{
              fontWeight: 600,
              fontSize: "2.5rem",
              textAlign: { xs: "center", lg: "left" },
            }}
          >
            Our Community
          </Typography>
          <Box
            sx={{
              display: { lg: "flex", md: "flex", xs: "block" },
              textAlign: { xs: "center", lg: "left" },
            }}
          >
            <Typography
              sx={{
                flex: { lg: 1 / 3, md: 1 / 2 },
                fontWeight: 400,
                fontSize: "1rem",
                color: "#4b5563",
              }}
            >
              Explore moments from our vibrant community of students, parents,
              and educators.
            </Typography>
            <Typography
              sx={{
                flex: { lg: 1 / 3, md: 1 / 2 },
                fontWeight: 400,
                fontSize: "1rem",
                color: "#4b5563",
                mt: { xs: 2, lg: 0, md: 0 },
              }}
            >
              See how Helpsoo is making a difference in schools around the
              world.
            </Typography>
          </Box>
          <Grid
            container
            rowSpacing={3}
            columnSpacing={{ xs: 1, md: 4, lg: 6 }}
            sx={{
              py: 7,
              justifyContent: { xs: "center" },
            }}
          >
            {CommunityData?.map((item) => {
              return (
                <Grid key={item}>
                  <Box
                    component={"img"}
                    src={item}
                    sx={{
                      objectFit: "cover",
                      width: "10rem",
                      height: "10rem",
                      aspectRatio: 4 / 3,
                      borderRadius: "0.5rem",
                    }}
                  ></Box>
                </Grid>
              );
            })}
          </Grid>
        </Box>
      </Box>
      <Address />
    </>
  );
};

export default Home;
